(function () {
  function initUrbanFitsCarousel() {
    var carousels = document.querySelectorAll("[data-uf-carousel]");

    carousels.forEach(function (carousel) {
      if (carousel.dataset.ufInitialized === "true") {
        return;
      }

      var track = carousel.querySelector("[data-uf-track]");
      var prev = carousel.querySelector("[data-uf-prev]");
      var next = carousel.querySelector("[data-uf-next]");

      if (!track || !prev || !next) {
        return;
      }

      carousel.dataset.ufInitialized = "true";

      function step() {
        return track.clientWidth * 0.8;
      }

      prev.addEventListener("click", function () {
        track.scrollBy({
          left: -step(),
          behavior: "smooth"
        });
      });

      next.addEventListener("click", function () {
        track.scrollBy({
          left: step(),
          behavior: "smooth"
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initUrbanFitsCarousel);
  } else {
    initUrbanFitsCarousel();
  }

  // Shopify Theme Editor mein section reload hone par bhi carousel initialize ho.
  document.addEventListener("shopify:section:load", initUrbanFitsCarousel);
})();